module.exports = __webpack_public_path__ + "img/alihelp.6e0f23a9.png";